import { Breadcrumb, Button, Col, Container, Form, Overlay, OverlayTrigger, Row, Tooltip } from 'react-bootstrap'
import { Dispatch, bindActionCreators } from 'redux'
import {
  DownloadVideo,
  License,
  ListTag,
  PreviewVideo,
  VideoDetail,
  BitcoinAddress,
  DefectReport,
  ViolationReport,
} from '~/components/video/[id]'
import React, { useEffect, useRef, useState } from 'react'
import { CheckNoAds, assetURL, buildHref, buildName, getAvatar, pathURL, redirectLogin } from '~/utils'
import { loadSimilarVideos, loadVideo } from '~/store/video/actions'
import { withI18n, withUser } from '~/hocs'

import { CommonProps } from 'types/app'
import { END } from 'redux-saga'
import Head from 'next/head'
import Link from 'next/link'
import { ListVideosSlide } from '~/components/common'
import MainLayout from '~/layout/MainLayout'
import { Meta } from '~/components/common/seo'
import { NextPage } from 'next'
import { PropsContext } from 'types/redux'
import RecommendService from '~/components/common/RecommendService'
import TextButton from '~/components/common/TextButton'
import VideoService from '~/services/VideoService'
import { commonMiddleware } from '~/middleware'
import { connect } from 'react-redux'
import { routes } from '~/router'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { setSelectedShareVideo } from '~/store/meta/actions'
import { useRouter } from 'next/router'
import { wrapper } from '~/store'
import { authOptions } from '~/pages/api/next-auth/[...nextauth]'
import { getServerSession } from 'next-auth/next'
import { NextAuthOptions } from 'next-auth'
import AliceCarousel from 'react-alice-carousel'
import 'react-alice-carousel/lib/alice-carousel.css'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import '@fortawesome/fontawesome-svg-core/styles.css'
import AuthService from '~/services/AuthService'
import dynamic from 'next/dynamic'
import { useSession } from 'next-auth/react'
import CommentVideo from '~/components/user/comment/CommentVideo'
import config from '~/config'
import CancleNotificationModal from '~/components/modals/CancleNotificationModal'
import ModalCreatorWork from '~/components/modals/ModalCreatorWork'
import GoogleAdsMaterial1Page from '~/components/common/Ads/GoogleAdsMaterial1Page'
import GoogleAdsMaterial2Page from '~/components/common/Ads/GoogleAdsMaterial2Page'
import GoogleAdsMateria1PremiumPage from '~/components/common/Ads/GoogleAdsMateria1PremiumPage'
import GoogleAdsMaterial2PremiumPage from '~/components/common/Ads/GoogleAdsMaterial2PremiumPage'
const Picker = dynamic(() => import('emoji-picker-react'), { ssr: false })

const Video: NextPage<any> = ({
  profile,
  video,
  // loadSimilarVideos,
  similarVideosProp,
  similarVideosMetaProp,
  // statusLoadSimilarVideos,
  relatedTags,
  setSelectedShareVideo,
  visitedVideos,
  t,
  lng,
  headerData,
  videoMeta,
  ilusts,
  isAuthen,
  isPremium,
}) => {
  const router = useRouter()
  const { asPath } = useRouter()
  const { id, slug, search } = router.query
  const { data: session } = useSession()
  const path = routes.video.as(id, slug)
  const [similarVideos, setSimilarVideos] = useState(similarVideosProp)
  const [similarVideosMeta, setSimilarVideosMeta] = useState(similarVideosMetaProp)
  const [statusLoadSimilarVideos, setStatusLoadSimilarVideos] = useState(similarVideosMeta)
  const [show, setShow] = useState(false)
  const [showDefect, setShowDefect] = useState(false)
  const [showBitcoin, setShowBitcoin] = useState(false)
  const [showSuccessViolation, setShowSuccessViolation] = useState(false)
  const [showFailedViolation, setShowFailedViolation] = useState(false)
  const [showSuccessDefect, setShowSuccessDefect] = useState(false)
  const [showFailedDefect, setShowFailedDefect] = useState(false)
  const [showCancleAccountModal, setShowCancleAccountModal] = useState(video?.user?.is_allow_login != 1 ? true : false)
  const [showWorkModal, setShowWorkModal] = useState(false)
  const handleCloseWorkModal = () => {
    setShowWorkModal(false)
  }
  const handleCloseCancleModal = () => {
    router.push(routes.home.href)
  }
  const [isLoading, setIsLoading] = useState(false)
  const wrapperRef = useRef()
  const bottomRef = useRef(null);
  // const [user, setUser] = useState(false)
  const [comments, setComments] = useState({
    content: '',
    parentCommentId: ''
  })
  const [replies, setReplies] = useState(
    {
      userId: '',
      creatorId: '',
      content: '',
      parentCommentId: ''
    }
  )
  const [height, setHeight] = useState('39px')
  const [isLoadingComment, setIsLoadingComment] = useState(false)
  const [showPicker, setShowPicker] = useState(false)
  const [commentsOfCreator, setCommentsOfCreator] = useState([])
  const [limit, setLimit] = useState(15)
  const [totalComments, setTotalComments] = useState(0)
  const handleClose = () => {
    setShow(false)
  }
  const handleCloseDefect = () => {
    setShowDefect(false)
  }
  const handleCloseBitcoin = () => {
    setShowBitcoin(false)
  }
  const handleShow = () => setShow(true)
  const handleShowDefect = () => setShowDefect(true)
  const handleShowBitcoin = () => setShowBitcoin(true)
  const responsive = {
    0: { items: 1 },
    568: { items: 2 },
    1024: { items: 5 },
  }
  const [showTooltip, setShowTooltip] = useState(false)
  const targetRef = useRef(null)

  const handleIconClick = () => {
    setShowTooltip(!showTooltip)
  }
  // useEffect(() => {
  //   if (session) {
  //     // profile.nick_name = session?.user.nickname
  //     // profile.avatar = session?.user.avatar
  //   }
  // }, [session])

  useEffect(() => {
    // loadUsers()
    getComment()
  }, [limit, session])

  useEffect(() => {
    if(asPath.includes("#commentID")) {
      const delay = 2000;
      const timeoutId = setTimeout(() => {
        if (bottomRef.current) {
          bottomRef.current.scrollIntoView({ behavior: 'smooth' });
        }
      }, delay);
      return () => clearTimeout(timeoutId);
    }
  }, []);
  

  useEffect(() => {
    function handleOutsideClick(event) {
      if (targetRef.current && !targetRef.current.contains(event.target)) {
        setShowTooltip(false)
      }
    }
    document.addEventListener('mousedown', handleOutsideClick)
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick)
    }
  }, [])
  // const [violation, setViolation] = useState({
  //   email: '',
  //   detail: '',
  // })

  // const [setLikedVideo] = React.useState(false)
  // useEffect(
  //   () => {
  //     loadSimilarVideos({ video_id: id, limit: 12, next: 0, lng })
  //   },
  //   [video],
  // )

  // const loadSimilarVideos = async (payload: any) => {
  //   setStatusLoadSimilarVideos(STATUS_LOAD.LOADING)
  //   await VideoService.getSimilar(payload)
  //     .then(({ data, meta }: any) => {
  //       setSimilarVideos([...similarVideos, ...data])
  //       setSimilarVideosMeta(meta)
  //     })
  //   setStatusLoadSimilarVideos(STATUS_LOAD.SUCCESS)
  // }
  // const loadUsers = async () => {
  //   await AuthService.getUserInfo({ id: profile.id })
  //     .then(res => { setUser(res.data) })
  //     .catch(() => undefined)
  // }


  useEffect(() => {
    setSimilarVideos(similarVideosProp)
    setSimilarVideosMeta(similarVideosMetaProp)
  }, [video])

  const onClickShareBtn = (e: any) => {
    e.preventDefault()
    setSelectedShareVideo(window.location.href)
  }
  const metaTitle = t('video:page_title', {
    id: video.id,
    title: video.title,
  })
  // const hanleBtnSeeMore = () => {
  //   loadSimilarVideos({
  //     video_id: id,
  //     limit: 24,
  //     next: similarVideosMeta.next,
  //   })
  // }
  const items = similarVideos.map((item: any) => {
    return <div className="item" data-value={item.id}>
      <ListVideosSlide videos={item} isAuthen={isAuthen} isPremium={isPremium} />
    </div>
  })
  // const handleUploadViolation = async() => {
  //   await VideoService.createViolation({
  //     video_id: video.id,
  //     email:violation.email,
  //     detail: violation.detail,
  //   })
  // }

  // const handleSaveBtn = () => {
  //   const idx = visitedVideos.find(x => x === id)
  //   console.log(visitedVideos)
  //   if(idx) {
  //     console.log('You saved this video!')
  //     return
  //   }
  //   addVisitedVideos(id)
  // }
  // const loadingSimirlar = statusLoadSimilarVideos === STATUS_LOAD.LOADING
  const formik = useFormik({
    initialValues: {
      email: '',
      detail: '',
      capcha: '',
    },
    validationSchema: Yup.object().shape({
      email: Yup.string().email('メールアドレス は メールの形式で入力して下さい。').required('※必須!'),
      detail: Yup.string().required('※必須!'),
      capcha: Yup.string().required('※必須!'),
    }),
    onSubmit: async values => {
      setIsLoading(true)
      try {
        const data = {
          video_id: video.id,
          email: values.email,
          detail: values.detail,
        }
        VideoService.createViolation(data).then(() => {
          setShowSuccessViolation(true)
          setIsLoading(false)
        }).catch((error) => {
          if (error.message == 'Add error') {
            setShowFailedViolation(true)
          }
        })
      } catch (error) {
      }
    },
  })
  const formikDefect = useFormik({
    initialValues: {
      file_type: '',
      detail: '',
    },
    validationSchema: Yup.object().shape({
      file_type: Yup.string().required('※必須!'),
      detail: Yup.string().required('※必須!'),
    }),
    onSubmit: async values => {
      setIsLoading(true)
      try {
        const data = {
          video_id: video.id,
          file_type: values.file_type,
          detail: values.detail,
        }
        VideoService.createDefect(data).then(() => {
          setShowSuccessDefect(true)
          setIsLoading(false)
        }).catch((error) => {
          if (error.message == 'Add Failed') {
            setShowFailedDefect(true)
          }
        })
      } catch (error) {
      }
    },
  })
  const  validateContent = (editcontent: string, base_url: string) => {
    if (base_url[base_url.length - 1] == '/') {
      base_url = base_url.slice(0, -1);
    }

    if (base_url) { 
      var text_error_url_other_site = '大変申し訳ございませんが、コメントの内容に不適切な%TYPE%が含まれているため、投稿できません。';
      var base_domain = base_url.replace('https://', '').replace('http://', '').replace('www.', '');
      var urls = editcontent.match(/(https?:\/\/[^\s]+)/g);
      if (urls) {
          for (var i = 0; i < urls.length; i++) {
              var url = urls[i].replace('https://', '').replace('http://', '').replace('www.', '');
              if (url.indexOf(base_domain) == -1) {
                  var type = 'URL';
                  alert('大変申し訳ございませんが、コメントの内容にURLが含まれているため、投稿できません。');
                  return false;
              }
          }
      }

      var emails = editcontent.normalize("NFKC").match(/([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/g);
      if (emails) {
          for (var i = 0; i < emails.length; i++) {
              var email = emails[i].replace('https://', '').replace('http://', '').replace('www.', '');
              if (email.indexOf(base_domain) == -1) {
                  var type = 'メールアドレス';
                  alert('大変申し訳ございませんが、コメントの内容にメールアドレスが含まれているため、投稿できません。');
                  return false;
              }
          }
      }

      let normalizedContent = editcontent.normalize("NFKC");
      let keywordPattern = /(cizucu[_\-]?[a-z0-9]*|[a-z0-9]*[_\-]?cizucu)/i;
      if (keywordPattern.test(normalizedContent)) {
          var type = '内容';
          alert('大変申し訳ございませんが、コメントの内容に不適切な内容が含まれているため、投稿できません。');
          return false;
      }
    }
    return true;
  }
  const onHandleComment = () => {
    const contentFiltered = removeEmptyLines(comments.content)
    if (validateContent(contentFiltered,"https://video-ac.com")) {
      if (contentFiltered.length > 0) {
        let isCreatorOfThisVideo = false
        if (video.user.id == profile.id) {
          isCreatorOfThisVideo = true
        }
        AuthService.createComment({ 
          videoId: id, 
          userId: profile.id, 
          content: removeEmptyLines(contentFiltered), 
          parentCommentId: comments.parentCommentId, 
          videoTitle: video.title,
          urlVideo: `${config.url.location}/video/${video.id}`,
          nickname: profile.nick_name, 
          isCreatorOfThisVideo}).then((res: any) => {
          setComments({
            content: '',
            parentCommentId: ''
          })
          setHeight('39px')
          getComment()
          setShowPicker(false)
        })
          .catch(() => {
            alert('エラー')
          })
      } else {
        alert('コメントを入力してください。')
      }
    }
  }
  const getComment = async () => {
    setIsLoadingComment(true)
    await AuthService.getComment({ videoId: id, limit, creatorId: null }).then((res: any) => {
      setCommentsOfCreator(res?.result?.data)
      setTotalComments(res?.result?.total)
    }).catch((err)=>{
      setIsLoadingComment(false)
      alert('エラー')
    }).finally(() => {
      setIsLoadingComment(false)
    })
  }
  const onHandleReply = (replies: any) => {
    const contentFiltered = removeEmptyLines(replies.content)
    if (contentFiltered.length > 0) {
      let isCreatorOfThisVideo = false
      if (video.user.id == profile.id) {
        isCreatorOfThisVideo = true
      }
      AuthService.createReply({ isCreatorOfThisVideo, 
        userId: replies.userId, 
        content: removeEmptyLines(contentFiltered), 
        parentCommentId: replies.parentCommentId, 
        videoTitle: video.title,
        urlVideo: `${config.url.location}/video/${video.id}`,
        nickname: profile.nick_name, 
        videoId: id, 
        creatorId: video?.user?.id }).then((res: any) => {
        getComment()
      })
        .catch(() => {
          alert('エラー')
        })
    } else {
      alert('コメントを入力してください。')
    }
  }
  const onHandleUpdate = (updateComment: any) => {
    const contentFiltered = removeEmptyLines(updateComment.content)
    if (contentFiltered.length > 0) {
      AuthService.updateComment({ id: updateComment.id, content: removeEmptyLines(contentFiltered) }).then((res: any) => {
        getComment()
      })
        .catch(() => {
          alert('エラー')
        })
    } else {
      alert('コメントを入力してください。')
    }
  }
  const onHandleDelete = (id: any) => {
    if (confirm("本当に削除しますか?") == true) {
      AuthService.deleteComment(id).then((res: any) => {
        // alert('削除成功')
        getComment()
      })
        .catch(() => {
          alert('削除に失敗しました')
        })
    }
  }
  const onHandleHide = (id: any) => {
    try {
      if (confirm("本当に非表示にしますか?") == true) {
        AuthService.hideComment(session?.token as string, id).then((res: any) => {
          // alert('非表示成功')
          getComment()
        })
      }
    } catch (error) {
      alert('隠れるに失敗しました')
    }
  }
  const onEmojiClick = (event: any, emojiObject: any) => {
    setComments({
      ...comments,
      content: comments.content + emojiObject.emoji,
    })
  }
  const removeEmptyLines = (inputString) => {
    const lines = inputString.split('\n')
    const filteredLines = lines.filter(line => line.trim() !== '')
    const result = filteredLines.join('\n')
    return result
  }
  const formatDuration = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `PT${minutes ? minutes + 'M' : ''}${remainingSeconds}S`;
  }
  return (
    <div onClick={(e) => {
      const { target } = e
      if (!wrapperRef.current?.contains(target)) {
        setShowPicker(false)
      }
    }}>
      <MainLayout path={path} headerData={headerData}>
      <Head>
        <title>{metaTitle}</title>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "VideoObject",
              "name": `${metaTitle}`,
              "description": `${t('video:page_description', {
                total_videos: (videoMeta && videoMeta.total) ? videoMeta.total : 0,
                title: video.title,
                tags: video.tags.map((vs: any) => vs.name).join(','),
              })}`,
              "thumbnailUrl": [
                `${assetURL(`${video?.pv_216}.jpg`)}`,
                `${assetURL(`${video?.pv_360}.jpg`)}`,
                `${assetURL(`${video?.pv_540}.jpg`)}`
              ],
              "uploadDate": `${video?.created_at}`,
              "duration": `${formatDuration(video?.duration)}`,
              "contentUrl": `${video.pv_540 ? assetURL(`${video.pv_540}.mp4`) : assetURL(`${video.upload.s3_key}`)}#t=${video.thumbnail_time}`,
            })
          }}
        />
      </Head>
      <Meta
        title={metaTitle}
        description={t('video:page_description', {
          total_videos: (videoMeta && videoMeta.total) ? videoMeta.total : 0,
          title: video.title,
          tags: video.tags.map((vs: any) => vs.name).join(','),
        })}
        image={assetURL(`${video.pv_360}.jpg`)}
        url={pathURL(path, lng)}
        keywords={t('video:page_keywords', {
          tags: video.tags.map((vs: any) => vs.name).join(','),
        })}
        type="article"
        twitter={true}
      />
      {/* <Container>
        <Breadcrumb>
          <Breadcrumb.Item href={buildHref({ pathname: routes.home.href, lng })}>
            {t('home')}
          </Breadcrumb.Item>
          <Breadcrumb.Item href={buildHref({ pathname: routes.discovery.href, query: { search }, lng })}>
            {search || t('discovery')}
          </Breadcrumb.Item>
          <Breadcrumb.Item active>
            {video.title || `#${video.id}`}
          </Breadcrumb.Item>
        </Breadcrumb>
      </Container> */}

      <Container>
      <CancleNotificationModal show={showCancleAccountModal} handleCloseCancleModal={handleCloseCancleModal} isProfilePage={false}/>
      <ModalCreatorWork show={showWorkModal} onHide={handleCloseWorkModal} creatorID={video.user?.id} creatorName={video.user?.nickname
                        ? <>{video.user?.nickname}</>
                        : <>{video.user?.email && video.user?.email.substring(0, 1) + '*****' + video.user?.email.substring(video.user?.email.length - 1, video.user?.email.length)}</>} />
        <Row>
          <Col xs={12}>
            <div className="ac-section-title ac-mb-2" style={{ height: "46px", marginTop: "34px" }}><h2>{video.title}</h2></div>
            {/* <Row>
              <Col xs={12} sm={12} md={6} lg={4}>
                <div className="video-info-head">
                  <div className="video-info-head-item mr-3">
                    <i className="fas fa-eye" />
                    <span className="video-info-head-item-data">
                      {kFormatter(video.view_count)}
                    </span>
                    <span className="video-info-head-item-name"> views</span>
                  </div>
                  <div className="video-info-head-item mr-3">
                    <i className="fas fa-arrow-down" />
                    <span className="video-info-head-item-data">
                      {kFormatter(video.download_count)}
                    </span>
                    <span className="video-info-head-item-name">
                      downloads
                    </span>
                  </div>

                  <div className="video-info-head-item text-primary">
                    <a onClick={onClickShareBtn} className="mr-3">
                      <i
                        className="fas fa-share-alt"
                        style={{ fontSize: '1rem' }}
                      />
                      <span
                        className="ml-1"
                        style={{ textDecoration: 'underline' }}
                      >
                        {t('share')}
                      </span>
                    </a>
                  </div>
                </div>
              </Col>
            </Row> */}
          </Col>

          <Col xs={12} md={6} lg={8} xl={8} className="pr-xl-3">
            <PreviewVideo video={video} />
            
            <div className="mt-2 mb-2">
              <OverlayTrigger
                key="top"
                placement="top"
                overlay={
                  <Tooltip id={`tooltip-top`}>
                    シェア
                  </Tooltip>
                }
              >
                <a onClick={onClickShareBtn} className="mr-3 mb-2">
                <i
                  className="fas fa-share-alt btn-share-video"
                />
              </a>
              </OverlayTrigger>
              <span className="float-right" style={{ fontSize: '14px' }}>作者: <Link href={{
                    pathname: routes.user.username.href,
                    query: { id: video.user?.id },
                  }} locale={lng}>
                    <a id="modal-provider-link" className="ac-text-blue" target="_blank">
                      <span id="modal-nickname">{video.user?.nickname
                        ? <>{video.user?.nickname}</>
                        : <>{video.user?.email && video.user?.email.substring(0, 1) + '*****' + video.user?.email.substring(video.user?.email.length - 1, video.user?.email.length)}</>}</span>
                    </a>
                  </Link></span>
            </div>
            
          </Col>
          <Col xs={12} md={6} lg={4} xl={4}>
            <DownloadVideo videoStocks={video.stocks} userID={profile.id} email={profile.email}/>
            <div className="hide-on-survey-show">
              <hr />
              <a href="https://help.freebie-ac.jp/detail/36" target="_blank" className="ac-text-blue ac-mr-1 link_hover">素材の利用方法</a>
              <a href="https://blog.acworks.co.jp/2018/12/10/ban/" target="_blank" className="ac-text-blue ac-mr-1 link_hover">禁止している素材の利用方法</a>
              {video?.right_of_use == 1 && <>
                <i
                  ref={targetRef}
                  className="fa fa-exclamation-circle"
                  style={{ color: '#FFCC33', fontSize: 18 }}
                  onClick={handleIconClick}
                >
                </i>
                <Overlay target={targetRef.current} show={showTooltip} placement="bottom">
                  {(props) => (
                    <Tooltip id="tooltip" {...props} className='tooltip-right-of-use'>
                      ご使用方法によっては、権利保有者や管理者の使用許可が必要な場合があります。
                    </Tooltip>
                  )}
                </Overlay>
              </>}
            </div>
            <div className="dropdown-divider" />
            <License />
          </Col>
          
          
          
          
        </Row>
        {similarVideos.length > 0 && <Col xs={12} md={12} lg={12} xl={12}>
            <div className="mt-3">
              <h2>関連動画</h2>
              <AliceCarousel
                mouseTracking
                items={items}
                responsive={responsive}
                controlsStrategy="alternate"
              />
            </div>
          </Col>}
        {
          !CheckNoAds(profile?.premium_info) && (isPremium ? <Row className='mb-2 google-ads bg-light'>
          <Col xs={12} md={6} lg={6} xl={6}>
            <GoogleAdsMateria1PremiumPage adId="div-gpt-ad-1731914440626-0" /> 
          </Col>
          <Col xs={12} md={6} lg={6} xl={6}>
          <GoogleAdsMateria1PremiumPage adId="div-gpt-ad-1731914440626-1" />
          </Col>
        </Row> : <Row className='mb-2 google-ads bg-light'>
          <Col xs={12} md={6} lg={6} xl={6}>
            <GoogleAdsMaterial1Page adId="div-gpt-ad-1731914288404-0" /> 
          </Col>
          <Col xs={12} md={6} lg={6} xl={6}>
          <GoogleAdsMaterial1Page adId="div-gpt-ad-1731914288404-1" />
          </Col>
        </Row>)
        }
        <Row>
        <VideoDetail video={video} lng={lng} />
          <Col xs={12} md={12} lg={8} xl={8}>
            <hr />
            <Row>
              <Col md={7} lg={8}>
              <span>本人確認： 本人確認済</span> <br/>     
              <span>
                この動画素材の投稿者
                <Link
                  href={{
                    pathname: routes.user.username.href,
                    query: { id: video.user?.id },
                  }}
                  locale={lng}
                >
                  <a className="text-blue hover hover-underline">
                    {buildName(video.user, lng)}
                  </a>
                </Link>
              さんは、本人確認が済んでいるクリエイターです。
              </span>  
              </Col>
              <Col md={5} lg={4}>
              {video?.model_status < 6 && video?.model_status > 2 && <>
                <span><Link href="https://help.freebie-ac.jp/detail/80">
                <a target="_blank" className="text-blue hover hover-underline">モデルリリース: </a></Link>取得済
              </span><br/>
              </>
              }
              {video?.property_status == 3 && <span><Link href="https://help.freebie-ac.jp/detail/81">
                <a target="_blank" className="text-blue hover hover-underline">プロパティリリース: </a></Link>取得済</span> }
              </Col>
            </Row>
          </Col>
          <Col xs={12} md={12} lg={8} xl={8}>
            <hr />
            <ListTag tags={relatedTags} videoID={id} />
          </Col>

          {
            video?.description && <Col xs={12} md={12} lg={8} xl={8}>
            <hr />
            説明： {video?.description}
          </Col>
          }
          {video?.user?.is_allow_send_email_work == 1  && <Col xs={12} md={12} lg={8} xl={8}>
            <hr />
            <div className="border-bottom ac-pb-1 ac-mb-1">
              <div className="align-items-end d-flex flex-wrap justify-content-between">
                <div className="flex-grow-1 d-sm-flex align-items-center flex-wrap ac-mb-md-0">
                    <p className="ac-mr-sm-1 ac-mb-1 ac-mb-sm-0">お仕事依頼:</p>
                    <button className="ac-btn mb-1 ml-2 border btn-send-mail-work ac-mb-1" type='button' onClick={()=>{setShowWorkModal(true)}}>
                      <i className="fa fa-envelope align-middle ac-d-md-inline ac-d-none ac-mr-1" aria-hidden="true"></i>
                      <span>{video.user?.nickname
                        ? <>{video.user?.nickname}</>
                        : <>{video.user?.email && video.user?.email.substring(0, 1) + '*****' + video.user?.email.substring(video.user?.email.length - 1, video.user?.email.length)}</>}さんにお仕事依頼メールを送る
                      </span>
                    </button>
                </div>
                <a className="align-middle ac-text-blue ac-mb-1" href="https://blog.acworks.co.jp/2024/09/12/how-to-job-requests/" target='_blank'>お仕事依頼とは? <i className="fa fa-angle-right" aria-hidden="true"></i></a>
              </div>
            </div>
          </Col>}
          <Col xs={12} md={6} lg={8} xl={8}>
            {/* Violation */}
            <ViolationReport formik={formik} video={video} show={show} setShow={setShow} handleClose={handleClose} showSuccessViolation={showSuccessViolation} isLoading={isLoading} />
            {/* End violation */}

            {/* Defect */}
            <DefectReport formikDefect={formikDefect} video={video} showDefect={showDefect} setShowDefect={setShowDefect} handleCloseDefect={handleCloseDefect} showSuccessDefect={showSuccessDefect}
              isLoading={isLoading} />
            {/* End Defect */}
            <div className="d-block d-sm-flex align-items-center justify-content-between border-bottom ac-pb-1 ac-mb-1 non-blur">
              <div className="ac-mb-1 ac-mb-sm-0 non-blur">
                <a href="#" className="ac-btn mb-1 border" data-toggle="modal" data-target="#contactFlagModal" onClick={handleShowDefect}>
                  <span data-toggle="tooltip" data-placement="top" data-original-title="破損している素材として報告する">
                    <img src="https://jp.static.photo-ac.com/assets/img/detail/corruption.svg" alt="" className="mr-1 lazy loaded" height="18" />
                    素材の不具合を報告する
                  </span>
                </a>
                <a href="#" className="ac-btn mb-1 ml-2 border" data-toggle="modal" data-target="#contactFlagModal" onClick={handleShow}>
                  <span data-toggle="tooltip" data-placement="top" data-original-title="不適切な写真として通報する 「より安心してご利用いただく為に、通報制度を設けています。」">
                    <img src="https://jp.static.photo-ac.com/assets/img/detail/violation.svg" alt="" className="mr-1 lazy loaded" height="18" />
                    違反報告
                  </span>
                </a>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={8} xl={8}>
            {
              video.categories.length > 0 ? <>
                {
                  video.categories.map(category => {
                    return <Breadcrumb>
                      <Breadcrumb.Item href={buildHref({ pathname: routes.home.href, lng })}>
                        <a className='text-link'>{t('video_ac')}</a>
                      </Breadcrumb.Item>
                      <Breadcrumb.Item href={buildHref({ pathname: routes.category.href, query: { id: category.id, name: encodeURIComponent(category[`name_${lng}`]) }, lng })}>
                        <a className='text-link'>{category[`name_${lng}`]}</a>
                      </Breadcrumb.Item>
                      <Breadcrumb.Item active>
                        {video.title || `#${video.id}`}
                      </Breadcrumb.Item>
                    </Breadcrumb>
                  })
                }
              </> : <Breadcrumb>
                <Breadcrumb.Item href={buildHref({ pathname: routes.home.href, lng })}>
                  {t('home')}
                </Breadcrumb.Item>
                <Breadcrumb.Item active>
                  {video.title || `#${video.id}`}
                </Breadcrumb.Item>
              </Breadcrumb>
            }
            <hr />
          </Col>
          {/* Bitcoin */}
          <Col xs={12} md={12} lg={12} xl={8}>
            <BitcoinAddress video={video} showBitcoin={showBitcoin} setShowBitcoin={setShowBitcoin} handleCloseBitcoin={handleCloseBitcoin} lng={lng} />
            <div className="ac-mb-3">
              <div className="mx-auto max-width-700">
                <div className="row no-gutters">
                  <div className="col-xl-7 col-lg-12 col-md-7">
                    <div className="bg-e6e6e6 ac-p-2 text-center h-100 d-flex flex-column align-items-center justify-content-center">
                      <p className="text-center"><strong>{buildName(video.user, lng)}さんをビットコインで応援しよう!</strong></p>
                      <div className="text-center d-flex align-items-center justify-content-center ac-mt-1">
                        <span className="align-middle"><img className="lazy loaded" src="https://jp.static.photo-ac.com/assets/profileimages/human/0-18.jpg" width="50" height="50" data-ll-status="loaded" /></span>
                        <span className="align-middle"><img width="89" className="d-block ac-mx-1 lazy loaded" src="/bitcoin_arrow_video.svg" data-ll-status="loaded" /></span>
                        <span className="align-middle"><img className="lazy loaded" src="https://jp.static.photo-ac.com/assets/profileimages/human/0-18.jpg" width="50" height="50" data-ll-status="loaded" /></span>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-5 col-lg-12 col-md-5 d-flex">
                    <a href="#" data-toggle="modal" data-target="#bitcoinModal" className="d-block w-100 text-decoration-none">
                      <div className="w-100 h-100 ac-bg-photo ac-p-2 text-center text-white d-flex flex-column align-items-center justify-content-center" onClick={handleShowBitcoin}>
                        <img src="/bitcoin_circle_video.svg" alt="" width="40" />
                        <p className="text-center ac-mt-1">
                          <strong>ビットコインアドレス<br />を確認</strong>
                        </p>
                      </div>
                    </a>
                  </div>
                </div>
                <div className="ac-mt-1 text-right">
                  <a className="" style={{ color: '#1C74B3' }} href="https://www.photo-ac.com/bitcoin/description/downloader" target="_blank">ビットコインとは？ <i className="fa fa-angle-right" aria-hidden="true" /></a>
                </div>
              </div>
            </div>
          </Col>
          {/* End Bitcoin */}
        </Row>
        
      </Container>
      {/* {!!similarVideos.length &&
        <div className="container video-container mt-4">
          <h5>{t('similar_video')}</h5>
          <ListVideos videos={similarVideos} />
          {
            similarVideosMeta.next &&
            <div className="d-flex justify-content-center">
              <Button
                style={{
                  lineHeight: '1.5rem',
                  // borderRadius: '4px',
                  boxShadow: 'none',
                  width: '9rem',
                  fontWeight: 600,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
                disabled={loadingSimirlar}
                onClick={hanleBtnSeeMore}
              >
                {loadingSimirlar && (
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    className="mr-1"
                  />
                )}
                <span>{t('more')}</span>
              </Button>
            </div>
          }
        </div>
      } */}
    {
     !CheckNoAds(profile?.premium_info) && <div
     style={{
       display: 'flex',
       justifyContent: 'center',
       alignItems: 'center',
       minWidth: '300px',
        minHeight: '90px',
     }}
     className='google-ads bg-light'
   >
     {isPremium ? <GoogleAdsMaterial2PremiumPage/> : <GoogleAdsMaterial2Page/>}
   </div>
    }
      <Container>
        <div className="dropdown-divider" />
        <RecommendService video={video} />
      </Container>

      <TextButton className="container mt-5" />

      <Container>
      {video?.user?.id !== 1 && <CommentVideo lng={lng} video={video} isLoadingComment={isLoadingComment} onHandleUpdate={onHandleUpdate} onHandleDelete={onHandleDelete}
    onHandleHide={onHandleHide} comments={comments} setComments={setComments} onHandleComment={onHandleComment} profile={profile} commentsOfCreator={commentsOfCreator} limit={limit} 
    setLimit={setLimit} totalComments={totalComments} replies={replies} setReplies={setReplies} onHandleReply={onHandleReply} showPicker={showPicker} setShowPicker={setShowPicker}
    height={height} setHeight={setHeight} onEmojiClick={onEmojiClick} wrapperRef={wrapperRef}/>}
      </Container>
      {/* Handle scrool to bottom */}
      <div ref={bottomRef}></div>
    </MainLayout>
    </div>
  )
}
export const getServerSideProps = wrapper.getServerSideProps(async (ctx: PropsContext) => {
  const session = await getServerSession(ctx.req, ctx.res, authOptions as NextAuthOptions)
  const creatorId = session?.user.creatorId

  const { store, locale, query } = ctx
  const start = new Date().getTime() / 1000
  console.log('Start loading', start)
  if (creatorId) {
    store.dispatch(loadVideo({ id: query.id, lng: locale, is_creator: true, user_id: creatorId }))
  } else {
    store.dispatch(loadVideo({ id: query.id, lng: locale }))
  }
  store.dispatch(loadSimilarVideos({ video_id: query.id, limit: 8, next: 0, lng: locale }))
  store.dispatch(END)

  let commonProps: CommonProps = {}
  const ilusts: any = []
  await Promise.all([
    store.sagaTask.toPromise(),
    commonMiddleware(ctx).then(res => {
      commonProps = res
      commonProps.headerData.has_search = true
    }),
  ])
  const state = store.getState()
  const video = state.video.video
  if (!video) {
    return {
      notFound: true,
    }
  }
  VideoService.view({ id: query.id })
  console.log('finsish', new Date().getTime() / 1000 - start)
  return {
    props: {
      ...commonProps,
      similarVideosMetaProp: state.video.similarVideosMeta,
      similarVideosProp: state.video.similarVideos,
      video: state.video.video,
      videoMeta: state.video.videoMeta,
      downloadInfo: state.video.downloadInfo,
      relatedTags: state.video.video ? state.video.video.tags : [],
      ilusts,
      ...(await serverSideTranslations(locale, ['common', 'video'])),
    },
  }
})

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({
  setSelectedShareVideo,
  // loadSimilarVideos,
  // addVisitedVideos,
}, dispatch)

export default connect(null,mapDispatchToProps)(withUser(withI18n(Video)))
